export const RETAIL_EVENTS = {
  ADD_TO_CART: 'add-to-cart',
  REMOVE_FROM_CART: 'remove-from-cart',
  PURCHASE: 'purchase-complete',
  PDP_VIEW: 'detail-page-view',
  CATEGORY_PAGE_VIEW: 'category-page-view',
  HOME_PAGE_VIEW: 'home-page-view',
  CART_PAGE_VIEW: 'shopping-cart-page-view',
}
